import React from 'react';
import {
  BreadcrumbProps,
  Container,
  Stack,
} from '@global-ecom/nitro-uds/elements';

import { MyAccountHeader } from 'ui/components/MyAccountHeader';
import { Breadcrumb } from 'ui/components/Breadcrumb';

export const LayoutAccountPage: React.FC<{
  title: string;
  subtitle?: string;
  className?: string;
  breadcrumb?: BreadcrumbProps['path'];
}> = ({ title, subtitle, breadcrumb, children }) => {
  return (
    <Container size="lg">
      <Stack gap="sm">
        {breadcrumb ? <Breadcrumb path={breadcrumb} /> : null}

        <Stack gap="xl">
          <MyAccountHeader title={title} subtitle={subtitle} />
          <Stack items="center" className="pb-8">
            {children}
          </Stack>
        </Stack>
      </Stack>
    </Container>
  );
};
